import React, { JSX } from 'react';
import styles from './Flex.module.scss';

type IntrinsicElement = keyof JSX.IntrinsicElements;

export interface IFlex<T extends IntrinsicElement> extends React.HTMLAttributes<HTMLElement> {
	as?: T;
}

export function FlexRow<T extends IntrinsicElement = 'div'>({ children, as = 'div' as T, ...props }: IFlex<T>) {
	const Tag = as as React.ElementType;
	return (
		<Tag
			{...props}
			className={`${styles.Flex} ${styles.row} ${props?.className}`}>
			{children}
		</Tag>
	);
}

export function FlexColumn<T extends IntrinsicElement = 'div'>({ children, as = 'div' as T, ...props }: IFlex<T>) {
	const Tag = as as React.ElementType;
	return (
		<Tag
			{...props}
			className={`${styles.Flex} ${styles.column} ${props?.className}`}>
			{children}
		</Tag>
	);
}
